import React from 'react';
import Carousel from 'react-material-ui-carousel';
import autoBind from 'auto-bind';
import {
    Paper,
    Button
} from '@material-ui/core'

import "./Carousel.css"

function Project(props)
{
    return (
        <Paper 
            className="Project"
            style={{
                backgroundColor: props.item.color,
                backgroundImage:props.item.image,
            }}
            elevation={10}
        >
            <image alt="carousel-image">{props.item.image}</image>
            <h2 className="texto1">{props.item.name}</h2>
            <p className="texto2">{props.item.description}</p>
            
        </Paper>
    )
}

const items = [
    {
        name: "Servicios financieros",
        description: "Soluciones innovadoras y de fácil acceso dirigidas a incrementar la inclusión financiera de todos los segmentos de la población de México.",
        Image:('https://res.cloudinary.com/dojodevs/image/upload/v1580446737/smartia/RECURSOS/Image_3_an3ixi.png'),
        color: "#E6F4F3"
    },
    {
        name: "Estrategias de Marketing",
        description: "Plataforma dedicada a manejar datos.",
        Image:('https://res.cloudinary.com/dojodevs/image/upload/v1580446741/smartia/RECURSOS/Image_1_jqnwtm.png'),
        color: "#d8f1f0"
    },
    {
        name: "Optimizar",
        description: "Plataforma dedicada a manejar datos.",
        Image:('https://res.cloudinary.com/dojodevs/image/upload/v1580446737/smartia/RECURSOS/Image2_wxncj3.png'),
        color: "#E6F4F3"
    }
]

export default class MyProjectsExample extends React.Component
{
    constructor(props)
    {
        super(props);

        this.state = {
            autoPlay: true,
            timer: 500,
            animation: "fade",
            indicators: true
        }

        autoBind(this);
    }

    toggleAutoPlay()
    {
        this.setState({
            autoPlay: !this.state.autoPlay
        })
    }

    toggleIndicators()
    {
        this.setState({
            indicators: this.state.indicators,
            color: "primary"
        })
    }

    changeAnimation(event)
    {
        this.setState({
            animation: event.target.value
        })
    }

    render()
    {
        return (
            <div style={{color: "#494949"}}>
                <Carousel 
                    className="Carousel"
                    autoPlay={this.state.autoPlay}
                    timer={this.state.timer}
                    animation={this.state.animation}
                    indicators={this.state.indicators}
                >
                    {
                        items.map( (item, index) => {
                            return <Project item={item} key={index} />
                        })
                    }
                </Carousel>
                
            </div>
        )
    }
}


/*<FormControlLabel
control={
    <Checkbox onChange={this.toggleIndicators} checked={this.state.indicators} value="indicators" color="primary"/>
}
label="Indicators"
/>*/


/*<FormControlLabel
control={
    <RadioGroup name="animation" value={this.state.animation} onChange={this.changeAnimation} row style={{marginLeft: "10px"}}>
        <FormControlLabel value="fade" control={<Radio color="primary"/>} label="Fade"/>
    </RadioGroup>
}
/>*/

/*<FormControlLabel
control={
    <Checkbox onChange={this.toggleAutoPlay} checked={this.state.autoPlay} value="autoplay" color="primary"/>
}
label="Auto-play"
/>*/